import { Redline } from 'redline-client-sdk';
import { RLAutoEvents } from '../types';

export const autoEvents = (rl: Redline): RLAutoEvents => ({
  pageViewed: () => {
    rl.dispatchSPAPathChange();
  },
});
